import service from '../service.js'

export default {
    /**
     * 获取产线列表数据
     * @returns 
     */
    Get: () => {
        return service({
            url: '/ProductionLines/Get',
            method: 'get',
        })
    },
}